export const queryKeys = {
  parcours: {
    all: ["parcours"] as const,
    list: (filters: Record<string, unknown>) => ["parcours", "list", filters] as const,
    detail: (id: string) => ["parcours", "detail", id] as const,
    members: (id: string) => ["parcours", "members", id] as const,
  },
  artists: {
    all: ["artists"] as const,
    list: (filters: Record<string, unknown>) => ["artists", "list", filters] as const,
    detail: (id: string) => ["artists", "detail", id] as const,
  },
  lieux: {
    all: ["lieux"] as const,
    list: (filters: Record<string, unknown>) => ["lieux", "list", filters] as const,
    detail: (id: string) => ["lieux", "detail", id] as const,
  },
  programmes: {
    all: ["programmes"] as const,
    list: (filters: Record<string, unknown>) => ["programmes", "list", filters] as const,
    detail: (id: string) => ["programmes", "detail", id] as const,
  },
  members: {
    all: ["members"] as const,
    list: ["members", "list"] as const,
    me: ["members", "me"] as const,
    detail: (id: string) => ["members", "detail", id] as const,
  },
};
